import Cookies from "js-cookie";
import toast from "@/services/Notification";
import HTTP from "@/_helpers/http";
import router from "@/router";
import { AUTHENTICATION__API } from "@/_helpers/urls";
import { AUTHENTICATION__MUTATIONS } from "../mutation-types";
import { AUTHENTICATION__ACTIONS } from "../action-types";
import { startTrackingInactivity } from "@/utils/inactivityTracker";

// State
const state = {
  token: null,
  el: 1,
  step: 1,
  loginInfo: {
    email: "",
    password: "",
    isApiLogin: "0",
  },
  resetInfo: {
    code: null,
    isReset: false,
    attempt: 0,
    new_password: "",
    confirm_password: "",
  },
  registerInfo: {
    owner_type: null,
    fname: "",
    lname: "",
    email: "",
    password: "",
    confirmPassword: "",
    otp: "",
    receivedOTP: "",
  },
  viewPassword: false,
  logOutTime: 0,
};

//Getters
const getters = {
  validToLogin(state) {
    return state.loginInfo.email && state.loginInfo.password;
  },
  validToRegister(state) {
    return (
      state.registerInfo.owner_type &&
      state.registerInfo.fname &&
      state.registerInfo.email &&
      state.registerInfo.password &&
      state.registerInfo.password.length >= 8 &&
      state.registerInfo.password === state.registerInfo.confirmPassword
    );
  },

  validToReset(state) {
    return !!state.resetInfo.email;
  },
};

//Mutations
const mutations = {
  [AUTHENTICATION__MUTATIONS.REGISTER_ACCOUNT_TYPE](state, type) {
    if (type === "Individual") {
      state.registerInfo.owner_type = 1;
    } else if (type === "Company") {
      state.registerInfo.owner_type = 2;
    }
  },

  [AUTHENTICATION__MUTATIONS.LOGIN_EMAIL](state, value) {
    state.loginInfo.email = value;
  },

  [AUTHENTICATION__MUTATIONS.UPDATESTEPPER](state, value) {
    state.el = value;
  },

  [AUTHENTICATION__MUTATIONS.LOGIN_PASSWORD](state, value) {
    state.loginInfo.password = value;
  },

  [AUTHENTICATION__MUTATIONS.RESET_NEWPASS](state, value) {
    // console.log(value)
    state.resetInfo.new_password = value;
  },

  [AUTHENTICATION__MUTATIONS.RESET_REPEATPASS](state, value) {
    // console.log(value)
    state.resetInfo.confirm_password = value;
  },
  [AUTHENTICATION__MUTATIONS.RESET_ATTEMPT](state, attempt) {
    state.resetInfo.attempt = attempt;
  },
  [AUTHENTICATION__MUTATIONS.RESET_CODE](state, code) {
    state.resetInfo.code = code;
  },
  [AUTHENTICATION__MUTATIONS.CREATEDTIME](state, time) {
    const twoMinutes = 2 * 60 * 1000;
    Cookies.set("verification-time", time, { expires: twoMinutes });
  },
  [AUTHENTICATION__MUTATIONS.SEND_EMAIL_TO](state, sendEmailTo) {
    state.resetInfo.sendEmailTo = sendEmailTo;
  },
  [AUTHENTICATION__MUTATIONS.TOKEN](state, data) {
    state.token = data.client.token;
    state.logOutTime = data.logOutTime;
  },
  [AUTHENTICATION__MUTATIONS.REMOVE_TOKEN](state) {
    state.token = null;
  },
  [AUTHENTICATION__MUTATIONS.REGISTER_FNAME](state, value) {
    state.registerInfo.fname = value;
  },
  [AUTHENTICATION__MUTATIONS.REGISTER_LNAME](state, value) {
    state.registerInfo.lname = value;
  },
  [AUTHENTICATION__MUTATIONS.REGISTER_EMAIL](state, value) {
    state.registerInfo.email = value;
  },
  [AUTHENTICATION__MUTATIONS.REGISTER_PASSWORD](state, value) {
    state.registerInfo.password = value;
  },
  [AUTHENTICATION__MUTATIONS.REGISTER_CONFIRM_PASSWORD](state, value) {
    state.registerInfo.confirmPassword = value;
  },
  [AUTHENTICATION__MUTATIONS.REGISTER_OTP](state, value) {
    state.registerInfo.otp = value;
  },
  [AUTHENTICATION__MUTATIONS.USER_OTP](state, value) {
    state.registerInfo.receivedOTP = value;
  },
  [AUTHENTICATION__MUTATIONS.RESET_REGISTER_INFO](state) {
    state.registerInfo.owner_type = "";
    state.registerInfo.fname = "";
    state.registerInfo.lname = "";
    state.registerInfo.email = "";
    state.registerInfo.password = "";
    state.registerInfo.confirmPassword = "";
  },
  [AUTHENTICATION__MUTATIONS.RESET_LOGIN_INFO](state) {
    (state.loginInfo.email = ""),
      (state.loginInfo.password = ""),
      (state.loginInfo.isApiLogin = "0");
  },

  [AUTHENTICATION__MUTATIONS.VIEW_PASSWORD](state) {
    state.viewPassword = !state.viewPassword;
  },

  [AUTHENTICATION__MUTATIONS.CHANGESTEP](state, value) {
    state.step = value;
  },
  setToken(state, newValue) {
    state.token = newValue;
  },
  removeToken(state) {
    state.token = null;
  }
};
// Actions
const actions = {
  async switchToClientPanel({ commit }) {
    try {
      const response = await HTTP().get('/switch-to-client');

      if (response.status === 200) {
        commit("removeToken");
        Cookies.remove("partner_panel", {
          domain: process.env.VUE_APP_DOMAIN_URL || undefined, // undefined for localhost
          secure: process.env.VUE_APP_SECURE === 'true', // Convert string to boolean
          sameSite: process.env.VUE_APP_SAME_SITE === 'None' ? 'None' : 'Lax' // Case-sensitive
        });
        window.location.href = response.data.ssoUrl;
      }
    } catch (error) {
      console.error(error);
    }
  },

  async setToken({ commit, dispatch }) {
    try {
      const url = new URL(window.location.href);
      const tokenParam = url.searchParams.get('token');

      const cookieData = Cookies.get('partner_panel');

      if (cookieData) {
        try {
          const authData = JSON.parse(cookieData);

          if (authData?.authentication?.token) {
            commit("setToken", authData.authentication.token);
            return;
          }

          await dispatch(AUTHENTICATION__ACTIONS.LOGOUT);
          return;
        } catch (e) {
          console.error('Cookie parse error:', e);
          await dispatch(AUTHENTICATION__ACTIONS.LOGOUT);
          return;
        }
      }

      //Check for token in URL param (SSO flow)
      if (tokenParam) {
        const token = encodeURIComponent(tokenParam);
        const response = await HTTP().get(`/sso-login?token=${token}`);

        if (response?.status === 200 && response.data?.token) {
          Cookies.set('partner_panel', JSON.stringify({
            authentication: { token: response.data.token }
          }), {
            expires: 1,
            domain: process.env.VUE_APP_DOMAIN_URL || undefined, // undefined for localhost
            secure: process.env.VUE_APP_SECURE === 'true', // Convert string to boolean
            sameSite: process.env.VUE_APP_SAME_SITE === 'None' ? 'None' : 'Lax' // Case-sensitive
          });
          commit("setToken", response.data.token);
          return;
        }
      }

      await dispatch(AUTHENTICATION__ACTIONS.LOGOUT);

    } catch (error) {
      await dispatch(AUTHENTICATION__ACTIONS.LOGOUT);
    }
  },

  async [AUTHENTICATION__ACTIONS.SENDREGISTEROTP]({ commit, state }) {
    try {
      const res = await HTTP().post(AUTHENTICATION__API.SENDREGISTEROTP, {
        email: state.registerInfo.email,
      });
      if (res.status === 200) {
        router.push("/send-otp");
        toast.success("OTP has sent to your email");
      }
    } catch (error) {
      console.log(error);
    }
  },

  async [AUTHENTICATION__ACTIONS.REGISTER]({ commit, state }) {
    try {
      const requestData = {
        fname: state.registerInfo.fname,
        lname: state.registerInfo.lname,
        email: state.registerInfo.email,
        password: state.registerInfo.password,
        owner_type: state.registerInfo.owner_type,
        otp: state.registerInfo.receivedOTP,
      };

      if (
        requestData.fname === null ||
        requestData.lname === null ||
        requestData.email === null ||
        requestData.password === null ||
        requestData.owner_type === null
      ) {
        return toast.error("Please fill all the fields");
      }

      const { data } = await HTTP().post(
        AUTHENTICATION__API.AUTHREGISTER,
        requestData
      );

      if (data.type === "success") {
        commit(AUTHENTICATION__MUTATIONS.RESET_REGISTER_INFO);
        toast.success(data.message);
        router.push("/");
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      console.error(error);
      toast.error(error.response.data.message);
    }
  },

  async [AUTHENTICATION__ACTIONS.LOGIN]({ commit, state }) {
    try {
      const { data } = await HTTP().post(AUTHENTICATION__API.AUTHLOGIN, {
        email: state.loginInfo.email,
        password: state.loginInfo.password,
        isApiLogin: state.loginInfo.isApiLogin,
      });

      if (data.type === "success") {
        commit(AUTHENTICATION__MUTATIONS.TOKEN, data);
        commit(AUTHENTICATION__MUTATIONS.RESET_LOGIN_INFO);
        toast.success(data.message);
        commit(AUTHENTICATION__MUTATIONS.UPDATESTEPPER, 1);
        router.push("/");
        if (state.logOutTime > 0) {
          startTrackingInactivity(this);
        }
        return;
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(error.response.data.message);
    }
  },

  async [AUTHENTICATION__ACTIONS.RESET]({ commit, state }) {
    try {
      const { data } = await HTTP().post(AUTHENTICATION__API.AUTHRESET);

      if (data.type === "success") {
        commit(AUTHENTICATION__MUTATIONS.CREATEDTIME, new Date().getTime());
        toast.success(data.message);
        state.step = 3;
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      toast.error(error.response.data.message);
    }
  },

  async [AUTHENTICATION__ACTIONS.CODEVERIFY]({ commit, state }) {
    try {
      const code = Number(state.resetInfo.code.trim());

      const { data } = await HTTP().post(AUTHENTICATION__API.AUTHCODEVERIFY, {
        code,
      });

      if (data.type === "success") {
        state.resetInfo.isReset = true;
        state.resetInfo.code = null;
        toast.success(data.message);
        state.step = 4;
      } else {
        state.resetInfo.isReset = false;
        state.resetInfo.code = null;
        toast.error(data.message);
      }
    } catch (error) {
      toast.error(error.response.data.message);
    }
  },

  async [AUTHENTICATION__ACTIONS.PASSRESET]({ commit, state }) {
    try {
      const { data } = await HTTP().post(
        AUTHENTICATION__API.AUTHRESETPASSWORD,
        {
          new_password: state.resetInfo.new_password,
          confirm_password: state.resetInfo.confirm_password,
        }
      );

      if (data.type === "success") {
        toast.success(data.message);
        router.push("/");
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      toast.error(error.response.data.message);
    }
  },

  async [AUTHENTICATION__ACTIONS.VERIFYACCOUNT]({ commit, state }) {
    try {
      const { data } = await HTTP().post(
        AUTHENTICATION__API.AUTHACCOUNTVERIFY,
        {
          email: state.resetInfo.sendEmailTo,
          code: state.resetInfo.code,
        }
      );

      if (data.type === "success") {
        toast.success(data.message);
        router.push("/");
      } else if (data.type === "invalid") {
        toast.error("Too many wrong attempts. Send code again!");
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      toast.error(error.response.data.message);
    }
  },

  async [AUTHENTICATION__ACTIONS.LOGOUT]({ commit }) {
    try {
      await HTTP().post(AUTHENTICATION__API.AUTHLOGOUT);
    } catch (error) {
      console.error('Logout API error:', error);
    } finally {
      Cookies.remove("partner_panel", {
        domain: process.env.VUE_APP_DOMAIN_URL || undefined, // undefined for localhost
        secure: process.env.VUE_APP_SECURE === 'true', // Convert string to boolean
        sameSite: process.env.VUE_APP_SAME_SITE === 'None' ? 'None' : 'Lax' // Case-sensitive
      });
      Cookies.remove("client_panel", {
        domain: process.env.VUE_APP_DOMAIN_URL || undefined, // undefined for localhost
        secure: process.env.VUE_APP_SECURE === 'true', // Convert string to boolean
        sameSite: process.env.VUE_APP_SAME_SITE === 'None' ? 'None' : 'Lax' // Case-sensitive
      });
      commit("removeToken");
      window.location.href = process.env.VUE_APP_CLIENT_URL
    }
  },

  async [AUTHENTICATION__ACTIONS.SUBMITOTP]({ commit, dispatch }) {
    try {
      await dispatch(AUTHENTICATION__ACTIONS.REGISTER);
    } catch (error) {
      console.error(error);
    }
  },

  async [AUTHENTICATION__ACTIONS.SENTFORGETPASSOTP]({ commit, state }, data) {
    try {
      const response = await HTTP().post(
        AUTHENTICATION__API.SENTFORGETPASSOTP,
        {
          email: data.email,
        }
      );
      toast.success("OTP has been sent to your email");
      commit(AUTHENTICATION__MUTATIONS.UPDATESTEPPER, 2);
    } catch (error) {
      console.log(error);
      toast.error(error?.response?.data?.message);
      commit(AUTHENTICATION__MUTATIONS.UPDATESTEPPER, 1);
    }
  },

  async [AUTHENTICATION__ACTIONS.FORGETPASSWORDCODE]({ commit, state }, data) {
    try {
      const res = await HTTP().post(AUTHENTICATION__API.FORGETPASSWORDCODE, {
        otp: data.otp,
      });
      if (res.status === 200) {
        toast.success(res.data.message);
        commit(AUTHENTICATION__MUTATIONS.UPDATESTEPPER, 3);
      }
    } catch (error) {
      toast.error(error?.response?.data?.message);
    }
  },

  async [AUTHENTICATION__ACTIONS.FORGETPASSWORDRESET](
    { commit, state },
    value
  ) {
    try {
      const { data } = await HTTP().post(
        AUTHENTICATION__API.AUTHFORGETPASSWORD,
        {
          email: value.email,
          new_password: value.new_password,
          confirm_password: value.confirm_password,
        }
      );

      if (data.type === "success") {
        toast.success(data.message);
        router.push("/");
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      toast.error(error.response.data.message);
    }
  },
};

export default {
  strict: process.env.NODE_ENV !== "production",
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
